// Lib
import { useEffect } from "react";
// Api
import { useGetHealthyPerkQuery } from "rtkQuery/query/healthyPerkAPI";
import { useGetLoyaltyQuery } from "rtkQuery/query/loyaltyAPI";
// Hooks
import { useNotification } from "hooks";
// Constants
import { rtkQueryParams } from "consts";
// Helpers
import { getModifiedData } from "../helpers";
// Utils
import { errorHandler } from "utils/errorHandler";

export const useGetPerksData = () => {
  const { openNotification } = useNotification();

  const {
    data: healthyPerksData,
    isFetching: healthyPerksIsFetching,
    error: healthyPerksError,
  } = useGetHealthyPerkQuery(null, rtkQueryParams);

  const {
    data: loyaltyTiersData,
    isLoading: loyaltyTiersIsLoading,
    error: loyaltyTiersError,
  } = useGetLoyaltyQuery(null);

  useEffect(() => {
    if (healthyPerksError) {
      errorHandler({ error: healthyPerksError, openNotification });
    }
  }, [healthyPerksError]);

  useEffect(() => {
    if (loyaltyTiersError) {
      errorHandler({ error: loyaltyTiersError, openNotification });
    }
  }, [loyaltyTiersError]);

  const modifiedData = getModifiedData(
    healthyPerksData?.data,
    loyaltyTiersData,
  );

  const isPerksDataLoading = healthyPerksIsFetching || loyaltyTiersIsLoading;

  return { healthyPerksData, modifiedData, isPerksDataLoading };
};
